namespace $.$$ {

	$mol_style_define( $shm_ba_search_settings, {
		display: 'grid',
		gap: '12px',
		alignItems: 'start',
		padding: {
			top: $mol_gap.block,
			bottom: $mol_gap.block,
		},

		Title: {
			font: {
				size: '18px',
				weight: 'bold',
			},
		},

		Mode_select: {
			maxWidth: '260px',
		},

		Case_sensitive: {
			justify: {
				self: 'start',
			},
		},

		Description: {
			color: $mol_theme.shade,
			maxWidth: '560px',
			userSelect: 'text',
		},
	} )

}
